import React, { Component } from "react";
import "./register.scss";
import { userService } from "../../../Services/User.Service";
import {
  Form,
  Icon,
  Input,
  Button,
  message,
} from "antd";
import { FormComponentProps } from "antd/es/form";
import registerIcon from "../../../Assets/icons/arranging_files.svg";
import seoIcon from "../../../Assets/icons/seo.svg";
import { authService } from "../../../Services/Public/cognito-auth";
import axios from "axios";
import { Link } from "react-router-dom";

// const { Option } = Select;
// const AutoCompleteOption = AutoComplete.Option;
interface UserFormProps extends FormComponentProps {
  age: number;
  name: string;
}
const formItemLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};
class register extends Component<any, any> {
  state = {
    loading: false,
    confirmDirty: false,
    autoCompleteResult: [],
  };

  componentDidMount() {}
  constructor(props: any) {
    super(props);

    userService.logout();
  }
  private toUsername(email: any): string {
    return email.replace("@", "-at-");
  }
  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        console.log("Received values of form: ", values);
        this.setState({ loading: true });

        authService.register(
          values.Email,
          values.Password,
          (success: any) => {
            this.setState({ loading: false });
            if (success) {
              message.success("You have successfully registered. ");
              authService.login(
                values.Email,
                values.Password,
                (success: any) => {
                  this.setState({ loading: false });
                  if (success) {
                    localStorage.setItem(
                      "TokenLimit",
                      success.accessToken.jwtToken
                    );
                    this.setState({ loading: true });
                    debugger;
                    axios
                      .get(
                        `${"https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/"}merchant?group=${"brand"}&email=${
                          values.Email
                        }`
                      )

                      .then((profile) => {
                        this.setState({ loading: false });

                        if (profile) {
                          message.success(" Welcome ");

                          let host = window.location.origin;
                          window.location.replace(host + "/panel/search");

                          localStorage.setItem(
                            "UserData",
                            JSON.stringify(profile.data)
                          );
                          localStorage.setItem(
                            "Token",
                            success.accessToken.jwtToken
                          );
                        }
                      })
                      .catch((error) => {
                        this.setState({ loading: false });
                      });
                  }
                },
                (error: any) => {
                  this.setState({ error, loading: false });
                  // message.error(error);
                  if (error.code == "UserNotConfirmedException") {
                    message.error(error.message);
                  } else if (error.code == "NotAuthorizedException") {
                    message.error(error.message);
                  } else {
                    message.error(" Invalid username or password! ");
                  }
                }
              );
            }
          },
          (error: any) => {
            this.setState({ error, loading: false });
            message.error(error);
          }
        );

        // userService.register(values).then(
        //     user => {
        //         this.setState({  loading: false });
        //         message.success(' شما با موفقیت ثبت نام کردید. ');
        //         this.setState({  loading: true });
        //          if(user.Success)
        //          {
        //              userService.login(values.Username, values.Password).then(
        //                  user => {
        //                      const { from } = this.props.location.state || {
        //                          from: { pathname: '/panel/search' }
        //                      };
        //                      message.success(' خوش آمدید ');
        //                      this.props.history.push(from);
        //                      this.setState({  loading: false });
        //                  },
        //                  error =>{
        //                      this.setState({ error, loading: false });
        //                      message.error(error);
        //                  }
        //              );
        //          }
        //
        //     },
        //     error =>{
        //         this.setState({ error, loading: false });
        //         message.error(error);
        //     }
        // );
      }
    });
  };

  handleConfirmBlur = (e: any) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule: any, value: any, callback: any) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("Password")) {
      callback(" The passwords you entered are not the same!");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule: any, value: any, callback: any) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  handleWebsiteChange = (value: any) => {
    let autoCompleteResult: any[];
    if (!value) {
      autoCompleteResult = [];
    } else {
      autoCompleteResult = [".ir", ".com", ".org", ".net"].map(
        (domain) => `${value}${domain}`
      );
    }
    this.setState({ autoCompleteResult });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    // const { autoCompleteResult } = this.state;
    // const prefixSelector = getFieldDecorator('prefix', {
    //     initialValue: '86',
    // })(
    //     <Select style={{ width: 70 }}>
    //         <Option value="86">+98</Option>
    //         {/*<Option value="87">+87</Option>*/}
    //     </Select>,
    // );

    // const websiteOptions = autoCompleteResult.map((website: any) => (
    //   <AutoCompleteOption key={website}>{website}</AutoCompleteOption>
    // ));
    return (
      <div className="registerContainer">
        <div className="registerForm">
          <div className="logo">
            <img src={registerIcon} alt="" />
          </div>

          <Form
            {...formItemLayout}
            onSubmit={this.handleSubmit}
            className="register-form"
          >
            {/*<Form.Item>*/}
            {/*{getFieldDecorator('Name', {*/}
            {/*rules: [{ required: false, message: 'لطفا نام خود را وارد کنید !' }],*/}
            {/*})(*/}
            {/*<Input*/}
            {/*prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
            {/*placeholder="نام"*/}
            {/*/>,*/}
            {/*)}*/}
            {/*</Form.Item>*/}
            {/*<Form.Item >*/}
            {/*{getFieldDecorator('Cellphone', {*/}
            {/*rules: [{ required: false, message: 'لطفا شماره تلفن خود را وارد کنید!' }],*/}
            {/*})(<Input*/}
            {/*prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
            {/*placeholder="شماره تلفن"*/}
            {/*style={{ width: '100%' }} />)}*/}
            {/*</Form.Item>*/}
            <Form.Item>
              {getFieldDecorator("Email", {
                rules: [
                  {
                    type: "email",
                    message: "Email Is Invalid !",
                  },
                  {
                    required: true,
                    message: " Please enter your email!",
                  },
                ],
              })(
                <Input
                  prefix={
                    <Icon type="tag" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Email"
                />
              )}
            </Form.Item>
            {/*<Form.Item>*/}
            {/*{getFieldDecorator('Username', {*/}
            {/*rules: [{ required: false, message: 'لطفا نام کاربری  خود را وارد کنید !' }],*/}
            {/*})(*/}
            {/*<Input*/}
            {/*prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
            {/*placeholder="نام کاربری"*/}
            {/*/>,*/}
            {/*)}*/}
            {/*</Form.Item>*/}
            <Form.Item>
              {getFieldDecorator("Password", {
                rules: [
                  {
                    min: 6,
                    message: "You must have at least 6 characters.",
                  },
                  { required: true, message: "Please enter your password!" },
                  {
                    validator: this.validateToNextPassword,
                  },
                ],
              })(
                <Input.Password
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Password"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator("RePassword", {
                rules: [
                  {
                    required: true,
                    message: "Please enter your confirm password!",
                  },
                  {
                    validator: this.compareToFirstPassword,
                  },
                ],
              })(
                <Input.Password
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Confirm Password!"
                  onBlur={this.handleConfirmBlur}
                />
              )}
            </Form.Item>

            {/*<Form.Item >*/}
            {/*{getFieldDecorator('website', {*/}
            {/*rules: [],*/}
            {/*})(*/}
            {/*<AutoComplete*/}
            {/*dataSource={websiteOptions}*/}
            {/*onChange={this.handleWebsiteChange}*/}
            {/*placeholder="وب سایت"*/}
            {/*>*/}
            {/*<Input*/}
            {/*prefix={<Icon type="ie" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
            {/*/>*/}
            {/*</AutoComplete>,*/}
            {/*)}*/}
            {/*</Form.Item>*/}

            <Form.Item>
              <Button
                type="primary"
                loading={this.state.loading}
                htmlType="submit"
                className="register-form-button"
              >
                Register
              </Button>
              Do you have an account?
              <Link to={"/login"} style={{ color: "#1890ff" }}>
                Login
              </Link>
            </Form.Item>
          </Form>
        </div>
        <div className="registerBg">
          <img src={seoIcon} alt="" />
        </div>
      </div>
    );
  }
}
export default Form.create<UserFormProps>({
  // ...
})(register);
